import React from 'react';
import './Stepp.css';

const Stepp = () => {
  return (
    <div className="container">
    <h2>Day-1</h2>

<div class="vl"></div>
<h2>Day-2</h2>
<div class="vl">Loremm </div>
<h2>Day-3</h2>
    
    </div>
  );
};

export default Stepp;